<template>
   <div>
      <v-container fluid class="pa-0">
         <v-row no-gutters class="pa-0">
            <v-col cols="12">
               <v-toolbar flat outlined>
                  <v-btn
                     :disabled="multiselect"
                     small
                     outlined
                     color="indigo"
                     class="pa-2"
                     @click="studentlistdlg = true"
                  >
                     <v-icon left small>mdi-plus</v-icon>
                     <template v-if="$vuetify.breakpoint.mdAndUp">Add To WaitList </template>
                  </v-btn>
                  <v-btn
                     :disabled="!multiselect"
                     small
                     outlined
                     color="indigo"
                     class="ml-4 pa-2"
                     @click="confirmWaitListRemoval"
                  >
                     <v-icon left small>mdi-minus</v-icon>
                     <template v-if="$vuetify.breakpoint.mdAndUp">Remove From Wait List </template>
                  </v-btn>
                  <v-btn
                     :disabled="!multiselect"
                     small
                     outlined
                     color="indigo"
                     class="ml-4 pa-2"
                     @click="checkConflictBeforeMove"
                  >
                     <v-icon left>mdi-arrow-up</v-icon>
                     <template v-if="$vuetify.breakpoint.mdAndUp">Move To Participants </template>
                  </v-btn>
                  <v-btn
                     :disabled="multiselect"
                     small
                     outlined
                     color="indigo"
                     class="ml-4 pa-2"
                     @click="reloadWaitList"
                  >
                     <v-icon left>mdi-refresh</v-icon>
                     <template v-if="$vuetify.breakpoint.mdAndUp">
                        Refresh
                     </template>
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-checkbox v-model="multiselect" class="mt-7 pb-0" @click="multiSelectClick">
                     <template v-slot:label>
                        <v-icon small left v-if="!$vuetify.breakpoint.mdAndUp">
                           mdi-check
                        </v-icon>
                        <template v-if="$vuetify.breakpoint.mdAndUp">
                           Select
                        </template>
                     </template>
                  </v-checkbox>
               </v-toolbar>
               <v-data-table
                  v-model="selectedwaitlist"
                  dense
                  :headers="waitlist_headers"
                  :items="waitlistdata"
                  item-key="school_id"
                  :single-select="!multiselect"
                  :show-select="multiselect"
                  @click:row="waitlist_rowClick"
               >
               </v-data-table>
            </v-col>
         </v-row>
      </v-container>
      <student-list
         :gender="gender"
         :year="year"
         :data="waitlistdata"
         :data2="ptcpdata"
         :dialogvisible.sync="studentlistdlg"
         @cancel-selection="studentlistdlg = false"
         @save-selection="onSaveStudentSelection"
      ></student-list>
      <confirm-dlg ref="confirm"></confirm-dlg>
      <confirm-reason-dlg ref="confirmreason" @save-reason="saveReason"></confirm-reason-dlg>
      <v-dialog
         v-model="showConflict"
         persistent
         width="550px"
         height="450px"
         @keydown.esc="showConflict = false"
      >
         <v-card flat>
            <v-card-title class="red white--text text-center">
               Schedule Conflict Detected.
            </v-card-title>
         </v-card>
         <v-card outlined class="pa-2">
            <v-data-table
               dense
               :items="conflictlist"
               :headers="conflict_headers"
               item-key="school_id"
               items-per-page="5"
            >
            </v-data-table>
            <div class="text-center">
               <v-btn color="primary" @click="showConflict = false">OK</v-btn>
            </div>
         </v-card>
      </v-dialog>
   </div>
</template>

<script>
   import ConfirmDlg from "@/components/ConfirmDlg.vue";
   import ConfirmReasonDlg from "@/components/ConfirmReasonDlg.vue";
   import StudentList from "@/components/StudentList.vue";

   export default {
      inject: ["ShowMessage"],

      components: {StudentList, ConfirmDlg, ConfirmReasonDlg},
      props: {
         max_participant: Number,
         cca_id: [Number, String],
         consent: [Boolean, Number],
         gender: Object,
         year: Array,
         ptcpdata: Array,
         waitlist_data: Array,
         ccafee: Number,
      },
      data() {
         return {
            ccaid: this.cca_id,
            selectedwaitlist: [],
            studentlistdlg: false,
            waitlist_headers: [
               {
                  text: "Code",
                  value: "student_code",
                  width: "10%",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Name",
                  value: "fullname",
                  width: "25%",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Gender",
                  value: "gendertext",
                  width: "10%",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Type",
                  value: "subtypetext",
                  width: "10%",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Year",
                  value: "ncyear",
                  width: "10%",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Submit Date",
                  value: "create_date",
                  width: "15%",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Consent",
                  value: "consentstatustext",
                  width: "10%",
                  class: this.$globalstore.table_smallheaderclass,
               },
            ],
            waitlistdata: this.waitlist_data,
            multiselect: false,
            actionReason: "",
            deleteReason: "",
            moveReason: "",

            showConflict: false,
            conflict_headers: [
               {
                  text: "Student Name",
                  value: "student_fullname",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Activity",
                  value: "cca_name",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Day",
                  value: "event_daytext",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Time",
                  value: "event_time",
                  class: this.$globalstore.table_smallheaderclass,
               },
            ],
            conflictlist: [],
         };
      },

      methods: {
         async onSaveStudentSelection(data) {
            this.studentlistdlg = false;

            if (data.length > 0) {
               await this.saveWaitList(data);
               await this.reloadWaitList();
               this.$emit("save-waitlist", this.waitlistdata);
            }
         },

         async reloadWaitList() {
            await this.$http({
               url: "/cca/getwaitlist.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  cca_id: this.cca_id,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.waitlistdata = response.data.waitlist;
                  }
               }
            });
         },

         multiSelectClick(event) {
            if (!this.multiselect) {
               this.selectedwaitlist = [];
            }
         },

         confirmWaitListRemoval() {
            if (this.selectedwaitlist.length > 0) {
               this.deleteReason = "";
               this.$refs.confirmreason
                  .open(
                     "Warning",
                     "Are you sure you want to remove the selected students? Please provide a reason below.",
                     {color: "orange"}
                  )
                  .then((reply) => {
                     if (reply) {
                        this.deleteReason = this.actionReason;
                        this.removeFromWaitList();
                     }
                  });
            }
         },

         saveReason(reason) {
            this.actionReason = reason;
         },

         async removeFromWaitList() {
            if (this.selectedwaitlist.length > 0) {
               await this.$http({
                  url: "/cca/removewaitlist.php",
                  headers: {
                     "Content-Type": "application/x-www-form-urlencoded",
                  },
                  data: {
                     cca_id: this.cca_id,
                     waitlist: this.selectedwaitlist,
                     reason: this.deleteReason,
                     userid: this.$globalstore.user.userid,
                     token: this.$globalstore.user.usertoken,
                  },
                  method: "POST",
               }).then((response) => {
                  if (response.data.autherror) {
                     this.$globalstore.user.tokenexpired = true;
                  } else {
                     if (response.data.error) {
                        this.ShowMessage({
                           title: "Error",
                           message: response.data.message,
                           color: "red",
                        });
                     } else {
                        this.reloadWaitList();
                     }
                  }
               });
            }
         },

         async checkConflictBeforeMove() {
            if (this.selectedwaitlist.length > 0) {
               this.$http({
                  url: "/cca/getsubscriptionconflict.php",
                  headers: {
                     "Content-Type": "application/x-www-form-urlencoded",
                  },
                  data: {
                     cca_id: this.cca_id,
                     checklist: this.selectedwaitlist,
                     userid: this.$globalstore.user.userid,
                     token: this.$globalstore.user.usertoken,
                  },
                  method: "POST",
               }).then((response) => {
                  if (response.data.autherror) {
                     this.$globalstore.user.tokenexpired = true;
                  } else {
                     if (response.data.error) {
                        this.ShowMessage({
                           title: "Error",
                           message: response.data.message,
                           color: "red",
                        });
                     } else {
                        if (response.data.conflicterror && response.data.conflictdata.length > 0) {
                           this.ShowConflictTable(response.data.conflictdata);
                        } else {
                           this.moveToParticipantList();
                        }
                     }
                  }
               });
            }
         },

         ShowConflictTable(data) {
            if (data) {
               this.conflictlist = data;
               this.showConflict = true;
            }
         },

         moveToParticipantList() {
            if (
               this.selectedwaitlist.length > 0 &&
               this.selectedwaitlist.length + this.ptcpdata.length > this.max_participant
            ) {
               this.ShowMessage({
                  title: "Error",
                  message: `You have reached the maximum of ${this.max_participant} participants.`,
                  color: "red",
               });
            } else {
               if (this.ccafee > 0) {
                  this.$refs.confirm
                     .open(
                        "Payment Required",
                        "This is activity requires payment for participation. " +
                           "A request for payment will be created for the selected students. " +
                           "Do you wish to continue?",
                        {color: "green", noconfirm: false}
                     )
                     .then((reply) => {
                        if (reply) {
                           this.$refs.confirmreason
                              .open(
                                 "Warning",
                                 "Are you sure you want to move the selected students to the participant list? " +
                                    "PLease provide a reason",
                                 {color: "orange", nocofirm: false}
                              )
                              .then((reply) => {
                                 if (reply) {
                                    this.moveReason = this.actionReason;
                                    this.doMoveToParticipantList();
                                    this.reloadWaitList();
                                 }
                              });
                        }
                     });
               } else {
                  this.$refs.confirmreason
                     .open(
                        "Warning",
                        "Are you sure you want to move the selected students to the participant list? " +
                           "PLease provide a reason",
                        {color: "orange", noconfirm: false}
                     )
                     .then((reply) => {
                        if (reply) {
                           this.moveReason = this.actionReason;
                           this.doMoveToParticipantList();
                           this.reloadWaitList();
                        }
                     });
               }
            }
         },

         async doMoveToParticipantList() {
            if (this.selectedwaitlist.length > 0) {
               await this.$http({
                  url: "/cca/movetoparticipantlist.php",
                  headers: {
                     "Content-Type": "application/x-www-form-urlencoded",
                  },
                  data: {
                     cca_id: this.cca_id,
                     movelist: this.selectedwaitlist,
                     reason: this.moveReason,
                     userid: this.$globalstore.user.userid,
                     token: this.$globalstore.user.usertoken,
                  },
                  method: "POST",
               }).then((response) => {
                  if (response.data.autherror) {
                     this.$globalstore.user.tokenexpired = true;
                  } else {
                     if (response.data.error) {
                        this.$refs.confirm.open("Error", response.data.message, {
                           color: "red",
                           noconfirm: true,
                        });
                     } else {
                        this.reloadWaitList();
                        this.$emit("update-participant");
                     }
                  }
               });
            }
         },

         waitlist_rowClick(item, row) {
            row.select(!row.isSelected);
         },

         async saveWaitList(data) {
            let response = await this.$http({
               url: "/cca/savewaitlist.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  cca_id: this.cca_id,
                  waitlist: data,
                  subtype: 2, // Invited
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.$refs.confirm
                        .open("Error", response.data.message, {
                           color: "red",
                           nocofirm: true,
                        })
                        .then((reply) => {});
                  }
               }
            });
         },
      },

      mounted() {
         if (this.$globalstore && this.$globalstore.appready) {
            // if (this.consent || this.consent == 1) {
            //    this.waitlist_headers.push({
            //       text: "Consent",
            //       value: "consenttext",
            //       width: "10%",
            //       class: this.$globalstore.table_headerclass,
            //    });
            // }
            this.reloadWaitList();
         }
      },
   };
</script>
